// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__anitg","paramInput":"JobSimulator_paramInput__O6AVk","input":"JobSimulator_input__3KTcX"};